"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePerformCardAction;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePerformCardAction() {
  return (0, _useWebChatAPIContext.default)().onCardAction;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VQZXJmb3JtQ2FyZEFjdGlvbi50cyJdLCJuYW1lcyI6WyJ1c2VQZXJmb3JtQ2FyZEFjdGlvbiIsIm9uQ2FyZEFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBOzs7O0FBRWUsU0FBU0Esb0JBQVQsR0FBNEU7QUFDekYsU0FBTyxxQ0FBdUJDLFlBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IERpcmVjdExpbmVDYXJkQWN0aW9uIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtY29yZSc7XG5cbmltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUGVyZm9ybUNhcmRBY3Rpb24oKTogKGNhcmRBY3Rpb246IERpcmVjdExpbmVDYXJkQWN0aW9uKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkub25DYXJkQWN0aW9uO1xufVxuIl19